import { Skeleton, Table } from "antd";
import PaginationInfo from "./PaginationInfo";
import PropTypes from 'prop-types';

export default function InfiniteTable({ dataSource, rowKey, loadMore, columns, title, paginationData, loading, hideRowNumber=false, ...restProps }) {
    if (!hideRowNumber && columns && columns.length > 0 && !columns.find(c => c.dataIndex === 'rowNumber')) {
        columns = [
            {
                title: 'N°',
                dataIndex: 'rowNumber',
                key: 'rowNumber',
                render: (text, record, index) => index + 1,
                width: 50,
                fixed: 'left'
            },
            ...columns
        ];
    }



    const handleScroll = (e) => {
        const { scrollTop, clientHeight, scrollHeight } = e.target;
        if (scrollHeight - scrollTop <= clientHeight + 20) {
            loadMore();
        }
    }


    return (
        <>
            <Table pagination={false} scroll={{ x: 1300, y: 450 }}
                rowKey={rowKey} onScroll={($e) => handleScroll($e)}
                dataSource={dataSource} columns={columns} {...restProps}
                title={
                    () => (
                        title
                    )
                } />
            <Skeleton loading={loading} active />
            <PaginationInfo loadedCount={dataSource.length ?? 0} paginationData={paginationData} />
        </>
    )
}

InfiniteTable.propTypes = {
    dataSource: PropTypes.array.isRequired,
    rowKey: PropTypes.string.isRequired,
    loadMore: PropTypes.func.isRequired,
    columns: PropTypes.array.isRequired,
    title: PropTypes.node,
    paginationData: PropTypes.object,
    loading: PropTypes.bool.isRequired,
    hideRowNumber: PropTypes.bool
};